import { create } from "zustand";
import type { NotificationRecord } from "./notificationModalStore";

interface NotificationStoreState {
  notificationList: NotificationRecord[];
  setInitialNotifications: (items: NotificationRecord[]) => void;
  prependNotification: (notification: NotificationRecord) => void;
  addNotification: (notification: NotificationRecord) => void;
  removeNotification: (id: string) => void;
  updateNotification: (
    id: string,
    updatedData: Partial<NotificationRecord>,
  ) => void;
  clearNotifications: () => void;
}

const useNotificationStore = create<NotificationStoreState>((set) => ({
  notificationList: [],

  setInitialNotifications: (initialNotifications) =>
    set({ notificationList: initialNotifications }),

  prependNotification: (notification) =>
    set((state) => {
      const withoutLast = state.notificationList.slice(0, -1);
      return { notificationList: [notification, ...withoutLast] };
    }),

  addNotification: (notification) =>
    set((state) => ({
      notificationList: [...state.notificationList, notification],
    })),

  removeNotification: (id) =>
    set((state) => ({
      notificationList: state.notificationList.filter((n) => n.id !== id),
    })),

  updateNotification: (id, updatedData) =>
    set((state) => ({
      notificationList: state.notificationList.map((n) =>
        n.id === id ? { ...n, ...updatedData } : n,
      ),
    })),

  clearNotifications: () => set({ notificationList: [] }),
}));

export { useNotificationStore };
